import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">精彩推荐</h2>
          <p className="text-sm text-foreground-500 mb-8">精选漫画推荐与精彩片段速览</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer ${
                  i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i >= 2 ? 'lazy' : undefined}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-4 right-4">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 text-xs bg-background-50/90 text-foreground-800 rounded-full whitespace-nowrap">
                      <i className="ri-play-circle-fill text-primary-500" />
                      推荐
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}